import { HttpClient } from '@angular/common/http';

import { BaseEntity } from '../entities/base/base.entity';
import { BaseService } from './base.service';

export abstract class BaseReadOnlyService<T extends BaseEntity> extends BaseService {

    constructor(protected http: HttpClient, actionUrl: string) {
        super(http, actionUrl);
    }

    getAll() {
        return this.http.get<T[]>(this.baseUrl);
    }

    get(id: number) {
        return this.http.get<T>(this.baseUrl + '/' + id);
    }
}
